
import BScroll from "@better-scroll/core"
import ware from "@/components/cms/ware.vue"
import { WARE_STATUS } from "@/constants/ware"

export default {
  name: "CmsWareTemplete",
  components: {
    // inputNumber,
    ware
  },
  props: {
    configData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      scroll: null,
      showArrow: true,
      showArrowLeft: false,
      wareData: [],
      groupTitle: "",
      seeAllText: "",
      seeAllColor: "",
      resourceUrl: "",
      curShow: 0,
      position: 0,
      subTitle: "",
      titleColor: "#000",
      subTitleColor: "#444"
    }
  },
  computed: {},
  watch: {
    configData: {
      handler(newVal) {
        this.wareData = this.transformData(newVal)
        this.groupTitle = newVal.groupFeature.showTitle ? newVal.groupFeature.titleNew : ""
        this.seeAllText = newVal.groupFeature.seeAllText ? newVal.groupFeature.seeAllText : ""
        this.seeAllColor = newVal.groupFeature.sellAllColor ? newVal.groupFeature.sellAllColor : ""
        this.resourceUrl = newVal.resource
        if (this.wareData.length <= 6) {
          this.showArrow = false
        }
        this.subTitle = newVal.groupFeature.showTitle ? newVal.groupFeature.subTitle : ""
        this.titleColor = newVal.groupFeature.titleColor || "#000"
        this.subTitleColor = newVal.groupFeature.titleColor || "#444"
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    const width = this.wareData.length * 1.76 + 0.08 * (this.wareData.length - 1)
    this.$refs.ware.style.width = width + "rem"
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.wareContent, {
        scrollX: true,
        click: true,
        probeType: 3,
        bounce: false,
        eventPassthrough: "vertical"
      })
      this.scroll.on("scroll", this.onScroll)
    })
  },
  methods: {
    transformData(data) {
      const result = []
      const subConfigList = data.subConfigList
      if (subConfigList.length) {
        for (let i = 0; i < subConfigList.length; i++) {
          const promotionPriceArr = subConfigList[i].additional?.promotionPrice.split(".")
          subConfigList[i].additional.promotionPriceVal = promotionPriceArr[0]
          subConfigList[i].additional.promotionPriceVal2 = promotionPriceArr[1] ? "" + promotionPriceArr[1] : "00"
          const nameArr = subConfigList[i].additional.name.split(" ")
          subConfigList[i].additional.nameVal = nameArr[0]
          subConfigList[i].additional.nameUnit = nameArr[1]
          subConfigList[i].additional.showSubTypeName =
            subConfigList[i].additional.promotionList && subConfigList[i].additional.promotionList.length > 1
              ? this.$t("common.multipleOffers")
              : subConfigList[i].additional.promotionList &&
                  subConfigList[i].additional.promotionList[0] &&
                  subConfigList[i].additional.promotionList[0].subTypeName
                ? subConfigList[i].additional.promotionList[0].subTypeName
                : ""
          subConfigList[i].additional.showSoldOut = [
            WARE_STATUS.OUT_OF_STOCK,
            WARE_STATUS.DISCONTINUED,
            WARE_STATUS.NOT_EXIST,
            WARE_STATUS.BLACKLIST
          ].includes(subConfigList[i].additional.wareStatus)
          if (subConfigList[i].additional.inBlackList) subConfigList[i].additional.showSoldOut = true
          subConfigList[i].additional.showComingSoon = [WARE_STATUS.COMING_SOON].includes(
            subConfigList[i].additional.wareStatus
          )
          subConfigList[i].index = i
          result.push(subConfigList[i])
        }
      }
      return result
    },
    handleArrowClick(type) {
      // 单个商品宽度目前为196px ,一行显示6.5个
      const curLen = 6 * 196
      this.curShow = type === "left" ? this.curShow - 1 : this.curShow + 1
      if (this.curShow < 0) {
        this.curShow = 0
      }
      let num = curLen * this.curShow
      if (num > Math.abs(this.scroll.maxScrollX)) {
        num = Math.abs(this.scroll.maxScrollX)
      }
      const move = -num
      this.scroll.scrollTo(move, 0, 300)
    },
    onScroll(pos) {
      // 判断结束,完整可视商品目前为6个
      const length = Math.ceil(Math.abs(pos.x / 196))
      if (pos.x == this.scroll.maxScrollX || (length && length == this.wareData.length - 6)) {
        this.showArrow = false
      } else {
        this.showArrow = true
      }
      this.showArrowLeft = Math.abs(pos.x) > 0
      this.$bus.$emit("handleCardsScroll")
    },
    showNotAvailable(baseInfo) {
      const { merchantId } = baseInfo
      if (process.client) {
        const { provincial } = JSON.parse(localStorage.getItem("curSelStore") || "{}")
        return !!(merchantId !== 2 && provincial && provincial !== { 0: 810000, 1: 820000 }[merchantId])
      }
      return false
    }
  }
}
